module.exports = "<div class=\"rg-details-wired\"></div>\n\n<h3 class=\"h4\">{{t('dnaDetails.wanLteTitle')|e}}</h3>\n<div class=\"rg-test-failover mb-lg\"></div>\n<div class=\"rg-details-lte\"></div>\n";
